import { tns } from 'tiny-slider'
import { addListener } from '../common/events'

const Slider = () => {
  const slider = tns({
    container: '.wwp3-js-slider-wrap',
    items: 3,
    slideBy: 1,
    mouseDrag: true,
    edgePadding: 40,
    gutter: 4,
    nav: false,
    controls: false,
  })

  addListener('.wwp3-js-slider-next', 'click', evt => {
    evt.preventDefault()
    slider.goTo('next')
  })

  addListener('.wwp3-js-slider-prev', 'click', evt => {
    evt.preventDefault()
    slider.goTo('prev')
  })
}

export default Slider



// WEBPACK FOOTER //
// src/assets/js/front-end/components/slider.js